import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";
import { RANGES } from "../myDashboardConstants";

export function RangeTabs({ value, onChange, options = RANGES }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target))
        setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  return (
    <div className="sd-range-dd-pos" ref={wrapRef}>
      <button
        type="button"
        className="sd-range-dd-btn"
        onClick={() => setOpen((v) => !v)}
      >
        <span>{value}</span>
        <FiChevronDown
          size={12}
          className={`sd-caret ${open ? "sd-caret-open" : ""}`}
        />
      </button>
      {open && (
        <div className="sd-dropdown sd-range-dd-menu">
          {options.map((r) => (
            <div
              key={r}
              className={`sd-dropdown-item ${value === r ? "sd-dropdown-item-active" : ""}`}
              onClick={() => {
                onChange(r);
                setOpen(false);
              }}
            >
              {r}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
